import { gql } from '../__generated__/gql';

export const SEND_NOTIFICATION_TO_EXTERNAL_API = gql(`
  mutation SendNotificationToExternalAPI($accessGrantId: String!, $userId: String!) {
    sendNotificationToExternalAPI(accessGrantId: $accessGrantId, userId: $userId)
  }
`);
